import React, { useEffect, useRef, useState } from "react";
import { Button, Menu, MenuItem, MenuDivider } from "@blueprintjs/core";
import { useOrg } from "../auth/OrgContext"; // adjust path if needed

export default function OrgSwitcher() {
  const { orgs, currentOrg, setCurrentOrg } = useOrg();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log("[OrgSwitcher] useOrg values:", { orgs, currentOrg });
  }, [orgs, currentOrg]);

  useEffect(() => {
    console.log("OrgSwitcher render → orgs:", orgs);
    console.log("OrgSwitcher render → currentOrg:", currentOrg);
  }, [orgs, currentOrg]);

  useEffect(() => {
    const closeOnClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeOnClickOutside);
    return () => document.removeEventListener("mousedown", closeOnClickOutside);
  }, [setOpen]);

  return (
    <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      <Button
        minimal
        icon="office"
        text={currentOrg?.name || "Select organization"}
        onClick={() => setOpen(!open)}
      />
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            zIndex: 9999,
            background: "white",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <Menu>
            {orgs.map((org) => (
              <MenuItem
                key={org.id}
                text={org.name}
                onClick={() => {
                  setCurrentOrg(org);
                  setOpen(false);
                }}
              />
            ))}
            <MenuDivider />
            <MenuItem
              icon="cog"
              text="Manage Organizations"
              href="/account/organizations"
            />
          </Menu>
        </div>
      )}
    </div>
  );
}
